import { splitChatLetters } from '../Chat/ColoredChatText';
import { Walker } from './actors';

export function villageNameParts(player: Pick<Walker, 'serverId' | 'name' | 'nameColors' | 'titleId'>, translate: (key: string) => string) {
  return [
    { text: `[S${String(player.serverId).padStart(2, '0')}] `, color: '#ffdf00' },
    ...splitChatLetters(player.name).map((text, index) => ({ text, color: /^#[0-9a-f]{6}$/i.test(player.nameColors?.[index] ?? '') ? player.nameColors![index] : '#ffffff' })),
    { text: player.titleId ? ` [${translate('title__' + player.titleId)}]` : '', color: '#ff4040' },
  ];
}
